import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';
import { createEnquirySchema } from '@/lib/forms/schemas/enquirySchema';

export const bloodTestEnquirySchema = createEnquirySchema({
  includePreferredContact: false,
});

export type BloodTestEnquiryValues = z.infer<typeof bloodTestEnquirySchema>;

export const bloodTestEnquiryDefaultValues: BloodTestEnquiryValues = {
  fullName: '',
  phone: '',
  email: '',
  preferredContact: undefined,
  message: '',
};

export const bloodTestEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    required: true,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone Number',
    placeholder: 'Enter your phone number',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    required: true,
    fullWidth: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'Enter your message',
    required: true,
    fullWidth: true,
  },
];
